import initialState from "./initialState";

const gameDataReducer = (state = initialState) => state;

export default gameDataReducer;
